module.exports = __webpack_public_path__ + "static/img/logo37.595d8d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo37.png
// module id = VcSY
// module chunks = 1